import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import Icon from '@amzn/meridian/icon';
import chevronUpLargeTokens from '@amzn/meridian-tokens/base/icon/chevron-up-large';
import chevronDownLargeTokens from '@amzn/meridian-tokens/base/icon/chevron-down-large';
export const ControlledExpander = ({ title, open = false, compact = false, children, }) => {
    const [isOpen, setOpen] = React.useState(open);
    const onExpanderClick = () => {
        setOpen(!isOpen);
    };
    return (_jsxs(Column, { spacingInset: compact ? '350' : '400 350', spacing: "300", "data-testid": "controlled-expander", children: [_jsx("div", { onClick: onExpanderClick, "data-testid": "expander-header", children: _jsxs(Row, { widths: ['fill', 'fit'], alignmentHorizontal: "justify", children: [_jsx(Text, { type: compact ? 'b200' : 'b400', children: _jsx("b", { children: title }) }), _jsx(Row, { alignmentHorizontal: "end", children: _jsx(Icon, { tokens: isOpen ? chevronUpLargeTokens : chevronDownLargeTokens, color: "primary" }) })] }) }), isOpen && children] }));
};
